import { useState } from "react";
import { useUserInfo } from "../../utils/security";
import {
    Avatar,
    Dialog,
    DialogTitle,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    SpeedDial,
    SpeedDialAction,
    SpeedDialIcon,
} from "@mui/material";
import { AddOutlined, EventRepeatOutlined } from "@mui/icons-material";

export const FinancialsSpeedDial = ({ onAddTransaction, onShowRecurringDialog }) => {
    const { userInfo } = useUserInfo();
    const [speedDialOpen, setSpeedDialOpen] = useState(false);
    const [transactionDialogType, setTransactionDialogType] = useState(undefined);

    return (
        <>
            <SpeedDial
                ariaLabel="Přidat transakci"
                sx={{ position: "absolute", bottom: 16, right: 16 }}
                icon={<SpeedDialIcon />}
                open={speedDialOpen}
                onOpen={() => setSpeedDialOpen(true)}
                onClose={() => setSpeedDialOpen(false)}>
                <SpeedDialAction
                    icon={<AddOutlined />}
                    tooltipTitle="Transakce..."
                    tooltipOpen
                    onClick={() => {
                        setSpeedDialOpen(false);
                        setTransactionDialogType("simple");
                    }}
                />
                <SpeedDialAction
                    icon={<EventRepeatOutlined />}
                    tooltipTitle="Opakovaná transakce..."
                    tooltipOpen
                    onClick={() => {
                        setSpeedDialOpen(false);
                        onShowRecurringDialog?.();
                    }}
                />
            </SpeedDial>
            {/* add new transaction dialog */}
            <Dialog
                onClose={() => setTransactionDialogType(undefined)}
                open={transactionDialogType === "simple"}>
                <DialogTitle>Vyberte typ transakce</DialogTitle>
                <List sx={{ py: 2, px: 2 }}>
                    {(userInfo?.transactionTypes || []).map((action) => (
                        <ListItem disableGutters key={action.id}>
                            <ListItemButton
                                autoFocus
                                onClick={() => {
                                    onAddTransaction?.(action);
                                    setTransactionDialogType(undefined);
                                }}>
                                <ListItemAvatar>
                                    <Avatar>
                                        <AddOutlined />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={action.name}
                                    secondary={action.description}
                                />
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Dialog>
        </>
    );
};
